
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/luxury-hotels-membership",
      function () {
        return require("private-next-pages/luxury-hotels-membership.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/luxury-hotels-membership"])
      });
    }
  